import { render } from "./name.vue?vue&type=template&id=dffcccb4&ts=true"
import script from "./name.ts?vue&type=script&lang=ts&external"
export * from "./name.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__